import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'convfact-privacydialog',
    templateUrl: './privacy-dialog.component.html',
    styleUrls: ['./privacy-dialog.component.scss'],
    standalone: false
})

export class PrivacyDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<PrivacyDialogComponent>
    ) { }

    closeDialog() {
        this.dialogRef.close();
    }

}
